import {CoreApi} from 'services/network/api';

const key = 'appSetting';


const getSettings = () => {
    const setting = JSON.parse(localStorage.getItem(key));
    return setting;
};

const setSettings = setting => {
    localStorage.setItem(key, JSON.stringify(setting));
};

const loadSettings = () => {
    CoreApi.GetAppSettings().then(res => {
        if (res.status == 200) {
            setSettings(res.data);
        }
    })
};

export {getSettings, loadSettings};